import { Alert, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAdminMode } from "./useAdminMode";

export const AdminPausedBanner = () => {
  const { t } = useTranslation();
  const { isAdminPaused, isSavingAdminMode, changeAdminMode } = useAdminMode();

  if (!isAdminPaused) {
    return null;
  }

  return (
    <Alert
      severity="info"
      square
      action={
        <Button
          color="inherit"
          size="small"
          disabled={isSavingAdminMode}
          onClick={() => {
            changeAdminMode("active");
          }}
        >
          {t("resumeAdmin")}
        </Button>
      }
    >
      {t("adminPausedBanner")}
    </Alert>
  );
};
